import { render } from "./ImportWeekCycle.vue?vue&type=template&id=c3c48dbe"
import script from "./ImportWeekCycle.vue?vue&type=script&lang=js"
export * from "./ImportWeekCycle.vue?vue&type=script&lang=js"

import "./ImportWeekCycle.vue?vue&type=style&index=0&id=c3c48dbe&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__